import {Component , OnInit} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'ft-print',
    templateUrl: './print.component.html',
    styleUrls: ['./print.component.scss'],
    imports: [MatButtonModule, MatIconModule]
})

export class PrintComponent implements OnInit {
    constructor(
    ) {

    }

    printPage() {
        window.print();
    }

    ngOnInit() {
    }
}
